import React from 'react'
import { useTheme } from '@config/themeContext'
import Editor from '@editor/index'

const EditorPage = () => {
  return (
    <div>
      <Editor></Editor>
    </div>
  )
}

export default EditorPage
